(function ($) {

  if ($(".tenant-slider .tenant-slide").length > 1) {
    $(".tenant-slider__slides").slick({
      centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 6000,
        cssEase: 'linear',
        draggable: false,
        swipe: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              autoplay: false,
              speed: 0,
              swipe: true,
              draggable: true,
            }
          }
        ]
    });
  }

})(jQuery);